// src/classes/class_bakingasteryniveays_1767154459985.js

const class_bakingasteryniveays_1767154459985 = {
  id: "bakingasteryniveays-1767154459985",
  title: "Baking Mastery In Five Days",
  date: "23* March",
  time: "10:30 AM – 5:30 PM * Tentative - will be confirmed",
  price: "Rs. 13,500 /-",
  type: "offline",
  details: `Day1 : Baking Fundamentals and 🍫Tea Cakes

✨Thai Butter cake
✨Marble Cake
✨pudding Cake

Day2 : 🍪Cookies & Brownies
✨Cookies:
Almond Biscotti
Chocolate center filling cookies
pinacolada cookies
Red velvet crinkle cookies

✨Brownies:
Hazelnut Brownie
White chocolate Blondie
Eggless Death By Chocolate Brownie

Day3: 🍮Desserts
  Caramel Flan
  Rose milk Tub Cake
  Strawberry Cheesecakes
  Mango Pannacotta
  Banoffee Shorts

Day4: Sponge Cakes& frosting

🎂Caramel sponge cake with milk chocolate caramel & fresh cream icing

🎂lemon Raspberry cake ( lemon sponge with lemon curd ,raspberry compote & frosted with fresh cream .

🎂German chocolate cakes with Belgium chocolate ganache

Day5:🧁 Cup Cakes and Decoration
5 Different cupcakes with filling and decoration with white chocolate buttercream & fresh cream ( chocolate garnishes )

Rich rasmalai cupcake
Strawberry cupcake
Mango cupcake
Choco lava cake
Ferro Rocher cupcake

Date : March 23rd to 27th(5 Days)
Fees: 13,500/-person
Timing : 10.30 am to 6 pm

Refreshments:
All ingredients will be provided
Recipe Printouts will be provided
Student kit
Both hands on and group hands on classes

Certification : Participants will receive a certification of completion.

No of seats :7

Address: 46/18, Gun Firing Street, Fort
Salem, Tamil Nadu

For Registration please WhatsApp to 07810940789 or send SMS to 078109 40789

23 March - 27 March`
};

export default class_bakingasteryniveays_1767154459985;
